import {EventBusCase} from "@/common/configurations/event-bus";

const DrcCommonLoadingMixin = {
	data() {
		return {
			isCommonDataLoaded: false,
		}
	},
	mounted() {
		this.$store.dispatch('setPrivateData');
		EventBusCase.$on('isLoaded', this.setIsLoaded)
	},
	beforeDestroy() {
		EventBusCase.$off('isLoaded')
	},
	methods: {
		setIsLoaded(isLoaded){
			this.isCommonDataLoaded = isLoaded;
		},
	}
}

export default DrcCommonLoadingMixin;
